module.exports = __webpack_public_path__ + "static/img/wx-logo.13e06e9f.png";